import { Box, FormControlLabel, Tooltip, Typography } from '@mui/material';
import React from 'react';

import WsTypography, { WsTypoColors, WsTypoVariants } from '../WsTypography/WsTypography';

export interface WsIconTextProps {
  icon: React.ReactElement;
  text: string | number;
  opacity?: boolean;
  textColor?: WsTypoColors;
  textSize?: WsTypoVariants;
  disable?: boolean;
  onClick?: (text: string | number) => void;
  textCursor?: 'pointer' | 'text';
  popOverText?: string;
  name?: string;
  isHtml?: boolean;
  isTextOverFlow?: boolean;
  maxWidth?: number | string;
}

const WsIconText = ({
  icon,
  text,
  opacity = false,
  textColor = WsTypoColors.BLACK,
  textCursor = 'text',
  onClick = () => null,
  disable = false,
  textSize = WsTypoVariants.BODY2,
  popOverText,
  name,
  isHtml = false,
  isTextOverFlow = false,
  maxWidth = '100%',
}: WsIconTextProps) => (
  <Tooltip title={popOverText ?? ''} placement="top">
    <FormControlLabel
      onClick={() => !disable && onClick(text)}
      control={icon}
      label={
        <Box pl={0.5}>
          {isTextOverFlow ? (
            <Typography
              variant={textSize}
              color={textColor}
              sx={{
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                maxWidth: { maxWidth },
                fontWeight: 500,
              }}
            >
              {text}
            </Typography>
          ) : !isHtml ? (
            <WsTypography
              cursor={textCursor}
              variant={textSize}
              color={textColor}
              opacity={opacity}
            >
              {text}
            </WsTypography>
          ) : (
            <Typography dangerouslySetInnerHTML={{ __html: String(text) }}></Typography>
          )}
        </Box>
      }
      name={name}
    />
  </Tooltip>
);

export default WsIconText;
